<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2" (mouseover)="showpayment(true,'5')" (mouseout)="showpayment(false,'5')"
                id="102">
                    <h2>Disputes </h2>
                </div>
                <div class="col-md-2 col2"><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a>  
                </div>
                <!-- <div class="col-md-12">
                    <div
                        style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe
                            class="i-frame"
                            src="https://www.youtube.com/embed/RLUj" title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                </div> -->
                <div class="col-md-12 mt-3" >
                    <label for="" (mouseover)="showpayment(true,'5')" (mouseout)="showpayment(false,'5')"
                    id="102">A dispute refers to a disagreement or conflict between two or more parties that may arise from differences in opinions, interests, or interpretations. Disputes can occur in various contexts, including personal relationships, business transactions, legal matters, and more. They can range from minor disagreements to major conflicts that require formal resolution processes.  </label>

                    <label for="" class="mt-4" (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')"
                    id="103"><b>Disputes and Chargebacks:
                        </b>&nbsp;A dispute,
                        also
                        known
                        as a
                        chargeback, occurs when a customer questions or disputes a charge that
                        appears
                        on
                        their
                        credit or debit card statement. This can happen for a variety of reasons,
                        such
                        as
                        not
                        recognizing the charge, suspecting fraudulent activity, or being
                        dissatisfied
                        with
                        the
                        product or service received. When a dispute is initiated, the payment
                        processor,
                        including PayG, is obligated to investigate the matter and resolve it fairly
                        for
                        both
                        parties involved. </label>

                    <label for="" class="mt-4" (mouseover)="showpayment(true,'4')" (mouseout)="showpayment(false,'4')"
                    id="104"><b>Fraud Prevention:</b>&nbsp; Fraud
                        is a serious
                        concern
                        in
                        the
                        online payment industry. It involves unauthorized or fraudulent transactions
                        carried
                        out
                        by individuals or groups with bad intentions. These transactions can be
                        damaging
                        to
                        both
                        customers and merchants, leading to financial losses and shattering the
                        customer’s
                        trust
                        in the payment process. To combat fraud, PayG employs advanced fraud
                        prevention
                        measures. These measures involve sophisticated algorithms and technologies
                        that
                        analyze
                        transaction patterns, IP addresses, device information, and more to identify
                        potentially
                        fraudulent activities. If a transaction raises red flags, it might be
                        flagged
                        for
                        further review or even blocked to protect both your business and the
                        customer.
                    </label>

                    <label for="" (mouseover)="showpayment(true,'4')" (mouseout)="showpayment(false,'4')"
                    id="104">Disputes and fraud prevention are integral aspects
                        of online
                        transactions
                        and
                        understanding them can help us work together to ensure a smooth and secure
                        payment
                        experience for your customers. If you ever have questions or concerns
                        regarding
                        these
                        matters, please don't hesitate to reach out. We're here to support you every
                        step of
                        the
                        way. </label>
             
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-4  hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        Table of Contents:
                    </h5>
                </div>
                <!-- <div class="col-md-12 mt-2">
                    <a href="#1"> <div class="row">
                        <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                alt=""> &nbsp;</div>
                        <div class="col-md-10">
                            <span style="cursor: pointer;" class="videoHover"
                                [ngClass]="{'video':colors=='1'}" (click)="color('1')">
                                E-Agreement </span>
                        </div>
                    </div></a>
                </div> -->
                <div class="col-md-12 mt-3">
                    <a href="#102">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='5'}"
                                    (click)="color('5')">
                                    What are disputes?  </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="#103">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                    (click)="color('3')">Disputes and Chargebacks 
                                </span>
                            </div>
                        </div>
                    </a>
                </div>

                <div class="col-md-12 mt-3 ">
                    <a href="#104">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='4'}"
                                    (click)="color('4')">Fraud Prevention at PayG 
                                </span>
                            </div>
                        </div>
                    </a>
                </div>



            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8">
                <a [routerLink]="['/refunds']">  <button class="btn btn-color" (click)="menues('Refunds')" > <img
                        src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;Refunds
                </button></a>
               
            </div>
            <div class="col-md-4   ">
                <a [routerLink]="['/pay-profile']"><button class="btn btn-color" (click)="menues('Pay Profile')" >Pay
                    Profile
                    &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
              
            </div>

        </div>
    </div>
</div>